// eslint-disable-next-line id-length
const compareFunction = (a, b) => {
    if (typeof a === 'string' && typeof b === 'string') {
        return a.localeCompare(b);
    }
    if (typeof a === 'number' && typeof b === 'number') {
        return a - b;
    }
    if (typeof a === 'boolean' && typeof b === 'boolean') {
        return Number(a) - Number(b);
    }
    throw new Error('Unsupported compare type');
};
export const isSameArray = (array1, array2) => {
    if (array1.length !== array2.length) {
        return false;
    }
    const sortedA = array1.slice().sort(compareFunction);
    const sortedB = array2.slice().sort(compareFunction);
    return sortedA.every((value, index) => value === sortedB[index]);
};
// eslint-disable-next-line unicorn/prefer-native-coercion-functions
export const notFalsy = (value) => Boolean(value);
export const notEmpty = (value) => value !== null && value !== undefined;
export const has = (data, property) => Object.prototype.hasOwnProperty.call(data, property);
export const hasChineseCharacter = (string) => Boolean(/[\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]/.test(string));
